import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import { Agreement } from "../../../clients/graphqlTypes.js";

const ALL_ACCEPTANCE_TYPES: Agreement[] = ["NONE", "YES", "NO"];

export function useQuoteAcceptanceTypes() {
  const { t } = useTranslate(["QuoteFilter"]);

  const acceptanceTypeLabels: Record<Agreement, string> = useMemo(
    () => ({
      NONE: t("None"),
      YES: t("Accepted"),
      NO: t("Declined"),
    }),
    [t]
  );

  const acceptanceTypeOptions = useMemo(
    () =>
      ALL_ACCEPTANCE_TYPES.map(status => ({
        value: status,
        label: acceptanceTypeLabels[status],
      })),
    [acceptanceTypeLabels]
  );

  return { acceptanceTypeLabels, acceptanceTypeOptions };
}
